import type { LiveUpdatePlugin } from '@capawesome/capacitor-live-update'

export const NATIVE_RUNTIME = 'capacitor8'
type UpdateClient = Pick<LiveUpdatePlugin, 'fetchLatestBundle' | 'getCurrentBundle' | 'getBlockedBundles' | 'downloadBundle' | 'setNextBundle'>

/** A minimum version protects old binaries; a runtime marker protects new ones. */
export async function stageNativeUpdate(client: UpdateClient, loginActive: () => Promise<boolean>): Promise<boolean> {
  const latest = await client.fetchLatestBundle()
  if (!latest.bundleId || !latest.downloadUrl || latest.customProperties?.nativeRuntime !== NATIVE_RUNTIME) return false
  const current = await client.getCurrentBundle()
  if (latest.bundleId === current.bundleId) return false
  const blocked = await client.getBlockedBundles()
  if (blocked.bundleIds.includes(latest.bundleId) || await loginActive()) return false
  // Use the very artifact whose compatibility was checked. sync() fetches again
  // and could choose another release while a channel is being changed.
  await client.downloadBundle({ bundleId: latest.bundleId, url: latest.downloadUrl,
    artifactType: latest.artifactType, checksum: latest.checksum, signature: latest.signature })
  if (await loginActive()) return false
  await client.setNextBundle({ bundleId: latest.bundleId })
  return true
}
